import { useQuery } from '@tanstack/react-query';

import { PERMISSION } from 'src/features/auth';
import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

type QueryFnType = typeof queryFn;
const queryFn = (parkingId: string): Promise<PERMISSION[]> => {
    return axios.get(formatResourcePath(`/user-permissions/?parking=${parkingId}`, { parkingId }));
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
    parkingId: string;
}
const useQueryHook = ({ config, parkingId }: UseQueryHookOptions) => {
    const RESOURCE = `/user-permissions/?parking=${parkingId}`;
    return useQuery({
        queryKey: [RESOURCE, parkingId],
        queryFn: async () => await queryFn(parkingId),
        ...config,
    });
};

export { useQueryHook as useGetPermissions };
